import NewLayout from "@components/new-ui/Layout";
import React, { FC } from "react";

const listItem = [
    "Access the billing/subscription section in your account",
    "Submit a cancellation request",
    "Complete the brief questionnaire provided",
    "Our customer support team will contact you to finalize the cancellation",
];
const CancellationPolicy: FC = () => {
    return (
        <NewLayout
            title="Cancellation Policy - Gallabox"
            description="Our cookie policy covers the use of cookies between your device and our site."
            canonical="https://gallabox.com/cookie-policy"
        >
            <section className="md:mt-36 max-w-6xl mx-auto px-10 md:px-0 mt-20">
                <h1 className="text-3xl text-center">CANCELLATION POLICY</h1>
                <section className="md:my-20 my-10">
                    <p className="font-bold">Cancellation Process</p>
                    <p className="mt-5">Customers may initiate cancellation requests from within the billing/subscription section of their account. The process is as follows:</p>

                    <ol>
                        {listItem.map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ol>

                    <section>
                        <p className="font-bold mt-5 mb-5">Effective Date</p>
                        <p>
                            Cancellations become effective at the end of the current billing cycle. Users will retain access to services until the end of their paid period. No
                            refunds will be provided for the remaining period of the subscription, except under special circumstances reviewed on a case-by-case basis.
                        </p>
                    </section>
                    <section>
                        <p className="font-bold mt-5 mb-5">Contact Information</p>
                        <p className="mt-5 mb-5">For refund or cancellation inquiries:</p>

                        <ol>
                            <li>Email: support@gallabox.com</li>
                        </ol>
                        <p>Our customer support team is committed to providing efficient and personalized assistance.</p>
                    </section>
                    <section>
                        <p className="font-bold mt-5 mb-5">Policy Updates</p>
                        <p>
                            Gallabox reserves the right to modify this policy at any time. Changes will be effective immediately upon posting the updated policy on our website.
                            Continued use of our services constitutes acceptance of any policy changes.
                        </p>
                        <p className="mt-5 mb-5 font-bold">Legal Compliance</p>
                        <p>
                            This policy complies with applicable laws and regulations in jurisdictions where Gallabox operates. For complete terms, please review our Terms of
                            Service and Privacy Policy.
                        </p>
                    </section>
                </section>
            </section>
        </NewLayout>
    );
};

export default CancellationPolicy;
